/**
 * PricingRoute — checkout landing; active subscribers skip back to dashboard.
 */

import { ReactNode } from 'react'
import { Navigate } from 'react-router-dom'
import { useQuery } from '@tanstack/react-query'
import { fetchBillingStatus } from '../../api/billing'
import { useAuth, isVendor } from '../../context/AuthContext'
import ContractorRoute from './ContractorRoute'

interface PricingRouteProps {
  children: ReactNode
}

export default function PricingRoute({ children }: PricingRouteProps) {
  const { user, loading: authLoading } = useAuth()

  const { data: billing, isLoading: billingLoading, isError } = useQuery({
    queryKey: ['billing-status'],
    queryFn: fetchBillingStatus,
    enabled: !!user && !isVendor(user),
    staleTime: 60_000,
    retry: false,
  })

  return (
    <ContractorRoute>
      {authLoading || (user && !isVendor(user) && billingLoading) ? (
        <div style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '100vh',
          background: 'var(--bg)',
        }}>
          <div className="auth-spinner" />
        </div>
      ) : user && !isVendor(user) && !isError && billing && !billing.blocked ? (
        <Navigate to="/dashboard" replace />
      ) : (
        children
      )}
    </ContractorRoute>
  )
}
